var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { GridContainer, GridItem } from './styles';
var Grid = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, rowId = _a.rowId, renderGridItem = _a.renderGridItem, 
    // appsGrid,
    gridMinWidth = _a.gridMinWidth;
    var identifier = React.useMemo(function () { return function (row) { return rowId && row[rowId] !== undefined ? row[rowId] : row.id; }; }, [rowId]);
    return (_jsx(GridContainer, __assign({ gridMinWidth: gridMinWidth }, { children: data.map(function (_a, index) {
            var item = _a.original;
            if (!item) {
                return null;
            }
            return (_jsx(GridItem, { children: renderGridItem(item, index) }, identifier(item)));
        }) })));
};
export default Grid;
